/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type GenericTableBadgeColorEnum = typeof GenericTableBadgeColorEnum[keyof typeof GenericTableBadgeColorEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenericTableBadgeColorEnum = {
  blue: 'blue',
  category_adjustment: 'category_adjustment',
  category_capital_call: 'category_capital_call',
  category_close: 'category_close',
  category_distribution: 'category_distribution',
  category_end_of_quarter_report: 'category_end_of_quarter_report',
  category_equalization: 'category_equalization',
  category_management_fee: 'category_management_fee',
  category_net_event: 'category_net_event',
  category_transfer_in: 'category_transfer_in',
  category_transfer_out: 'category_transfer_out',
  cyan: 'cyan',
  dark_gray: 'dark_gray',
  default: 'default',
  eggplant: 'eggplant',
  error: 'error',
  indigo: 'indigo',
  pink: 'pink',
  primary: 'primary',
  purple: 'purple',
  success: 'success',
  teal: 'teal',
  warning: 'warning',
} as const;
